import { Link } from 'react-router-dom';
import type { ShopListItem } from '../api';
import { ProductCard } from '../storefront/ProductCard';

/**
 * Vodorovná řada dlaždic – související produkty, naposledy prohlížené.
 *
 * Stejná kostra jako pás v katalogu (`.block.product-row` → `.rail`), takže
 * řady vypadají všude identicky a dědí i responzivní chování (mřížka na
 * širokém, posuvník na mobilu). Prázdná řada se nevykreslí – pás s nadpisem
 * bez zboží vypadá jako chyba.
 */
export function ProductRail({
  title,
  items,
  moreHref,
  moreLabel,
}: {
  title: string;
  items: readonly ShopListItem[];
  moreHref?: string;
  moreLabel?: string;
}) {
  if (items.length === 0) return null;

  return (
    <section className="block product-row">
      <div className="block-head">
        <h2 className="block-title">{title}</h2>
        {moreHref !== undefined && moreLabel !== undefined && (
          <Link className="block-more" to={moreHref}>
            {moreLabel} <span aria-hidden="true">→</span>
          </Link>
        )}
      </div>

      <div className="rail">
        {items.map((product, index) => (
          <ProductCard key={product.id} product={product} index={index} />
        ))}
      </div>
    </section>
  );
}
